import mobxState from '@src/store/monitor';
import { ajax } from '@clouderwork/ywk';
import { IDepartments } from '@src/entity/okr/okr';
import { action, observable } from 'mobx';
import { INameIdProp } from '../user';
import { IMemberAndDepart } from '@src/entity/company/project';

class Desktop {
  constructor() {}

  @observable pagenum: [number, number] = [0, 0];
  @observable pagesize: [number, number] = [10, 10];

  @observable total: [number, number] = [0, 0];

  @observable loading: [boolean, boolean] = [true, true];
  @observable next: [boolean, boolean] = [true, true];

  @observable work_type: INameIdProp | undefined;

  @observable list: [any[], any[]] = [[], []];

  @observable previewItem: any;

  @observable filter_members: any[] = [];

  @observable fetchingDepartments: boolean = false;
  @observable departments: IDepartments | undefined = undefined;

  @action.bound
  async getDesktopList(index: number, params: any = {}) {
    this.loading[index] = true;
    let memberUuid: any = [];
    let departUuid: any = [];
    for (let item of this.filter_members) {
      item.type === 'person' && memberUuid.push(item.uuid);
      item.type === 'department' && departUuid.push(item.uuid);
    }
    const res = await ajax.getJson('/monitor/api/desktop', {
      pagenum: this.pagenum[index] + 1,
      pagesize: this.pagesize[index],
      work_type: this.work_type ? this.work_type.id : undefined,
      members_uuid: memberUuid.join(','),
      departments_uuid: departUuid.join(','),
      ...params
    });
    this.loading[index] = false;

    if (res.error_code === 0) {
      const { results: data, pagenum, total } = res;

      if (pagenum === 1) {
        this.list[index] = data;
      } else {
        this.list[index] = (this.list[index] || []).concat(data);
      }

      this.pagenum[index] = pagenum;
      this.next[index] = this.list[index].length < total;
      this.total[index] = total;

      return true;
    }
    return false;
  }

  @action.bound
  async getOneDesktopItem(members_uuid: string) {
    const res = await ajax.getJson('/monitor/api/desktop', {
      pagenum: 1,
      pagesize: 1,
      members_uuid
    });
    if (res.error_code === 0 && res.results.length > 0) {
      const item = res.results[0];

      this.previewItem = item;

      for (let tabindex = 0; tabindex < this.list.length; tabindex++) {
        const memberlist = this.list[tabindex];
        const curIndex = memberlist.findIndex(m => m.user_uuid === members_uuid);

        console.log('found in list', tabindex, 'at', curIndex);

        if (curIndex >= 0) {
          memberlist.splice(curIndex, 1, item);
          console.log('替换后', memberlist[curIndex]);
          this.list[tabindex] = [...memberlist];
        }
      }
    }
  }

  /** 获取部门树 */
  @action.bound
  async getDepartments() {
    this.fetchingDepartments = true;
    let outReq: Promise<any> = new Promise(() => {});
    const inReq = ajax.getJson('/monitor/api/user/departments', {
      just_department: 0
    });

    if (mobxState.user.curUserInfo && mobxState.user.curUserInfo.out_permission) {
      outReq = this.getOutMembers();
    }

    const inRes = await inReq;
    const outRes = await outReq;

    this.fetchingDepartments = false;

    let departments: any[] = [];

    if (outRes && outRes.error_code === 0) {
      departments.push({
        avatar: null,
        children: outRes.results,
        groupSeq: -1,
        id: 'out',
        jobPositionName: null,
        key: 'out',
        memberType: null,
        phone: null,
        title: '外部成员',
        type: 'department'
      });
    }

    if (inRes.error_code === 0 && inRes.results) {
      const { children } = inRes.results;
      departments = departments.concat(children);
      this.departments = { ...inRes.results, children: departments };
    }
  }

  @action.bound
  getOutMembers() {
    return ajax.getJson('/monitor/api/user/out');
  }
}

export default Desktop;
